// extracted by mini-css-extract-plugin
export default {"link":"WebsiteCreated_link__+aQWl","list":"WebsiteCreated_list__cjp0f"};